export const getTranslatedField = (item, fieldName, language) => {
    if (!item || !fieldName || !language) return '';

    return item[`${fieldName}_${language}`] || item[`${fieldName}_en`] || '';
};
